module.exports = __webpack_public_path__ + "img/Butterfly_00339.b68dc2cc.png";